import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-emerald-50 to-orange-50">
      <header className="bg-black text-white">
        <nav className="max-w-7xl mx-auto px-4 py-3 flex items-center">
          <div className="flex items-center space-x-6">
            <Link to="/" className="flex items-center">
              <img
                src="https://rentreview.io/wp-content/uploads/2025/05/Rent-Review-Logo.png"
                alt="RentReview"
                className="h-9"
              />
            </Link>
            <Link to="/leave-review" className="text-sm">Leave a Review</Link>
          </div>
        </nav>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-sm p-12">
          <div className="space-y-8">
            <div className="border-b pb-8">
              <h1 className="text-4xl font-bold mb-4">Terms & Conditions</h1>
              <div className="text-gray-600">
                <p>Effective Date: 8th August 2025</p>
                <p>Last Updated: 8th August 2025</p>
              </div>
            </div>

            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 mb-6">
                Welcome to RentReview ("we", "us", "our"). By accessing or using our website (the "Site"), you agree to these Terms & Conditions. If you do not agree, you must not use our Site.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">1. Eligibility</h2>
              <p className="text-gray-700 mb-4">You must be 18 years or older to use this Site. By submitting a review, you confirm that:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>You have personally experienced the property, landlord, letting agent, or company you are reviewing.</li>
                <li>The information you provide is truthful and accurate to the best of your knowledge.</li>
              </ul>

              <h2 className="text-2xl font-bold mt-8 mb-4">2. Nature of Reviews & Content Disclaimer</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>All reviews, ratings, and comments on RentReview are user-generated content.</li>
                <li>They represent the personal opinions and experiences of the individuals who posted them.</li>
                <li>We do not verify the accuracy of reviews and do not endorse any statements made by users.</li>
                <li>You acknowledge that reviews may contain subjective opinions and should not be treated as statements of fact.</li>
                <li>We accept no liability for any loss or damage arising from reliance on reviews.</li>
              </ul>

              <h2 className="text-2xl font-bold mt-8 mb-4">3. User Conduct Rules</h2>
              <p className="text-gray-700 mb-4">You agree not to post any content that:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Is false, misleading, defamatory, libellous, or otherwise unlawful.</li>
                <li>Contains discriminatory, hateful, racist, homophobic, sexist, or otherwise targeted abusive language.</li>
                <li>Includes threats, harassment, or incitement to violence.</li>
                <li>Violates the rights of any third party, including copyright and privacy rights.</li>
                <li>Includes personal information about another person without their consent.</li>
              </ul>
              <p className="text-gray-700 mt-4 mb-4">
                We allow the use of non-targeted swearing in reviews to express opinion or emphasis, provided it is not directed at an individual or group in a way that is abusive, harassing, or discriminatory.
              </p>
              <p className="text-gray-700">
                We use AI-assisted moderation tools in combination with human review to detect prohibited content, including but not limited to hate speech, harassment, and discriminatory remarks. Any content flagged by our systems may be edited, hidden, or removed at our sole discretion, without notice.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">4. Our Rights Over Content</h2>
              <p className="text-gray-700 mb-4">
                By submitting content to RentReview, you grant us a worldwide, royalty-free, perpetual, irrevocable licence to use, reproduce, modify, distribute, display, and publish your content in any media, including for marketing, promotional, and research purposes.
              </p>
              <p className="text-gray-700 mb-4">You acknowledge that:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>We may share reviews (including your name if publicly displayed) with landlords, letting agents, or companies mentioned in the review.</li>
                <li>We may remove, edit, or refuse to publish any content at our discretion, without notice.</li>
              </ul>

              <h2 className="text-2xl font-bold mt-8 mb-4">5. Notifications to Landlords & Agents</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>If your review mentions a landlord, letting agent, housing association, or property owner, we may notify them and share your review in full.</li>
                <li>We will not share your contact details unless required by law or you have expressly agreed.</li>
              </ul>

              <h2 className="text-2xl font-bold mt-8 mb-4">6. Limitation of Liability</h2>
              <p className="text-gray-700 mb-4">To the fullest extent permitted by UK law:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>We are not liable for any content posted by users.</li>
                <li>We are not responsible for the accuracy, reliability, or completeness of any review.</li>
                <li>We are not liable for any loss, damage, or harm arising from your use of the Site or reliance on any content.</li>
              </ul>
              <p className="text-gray-700 mt-4">
                Nothing in these Terms excludes liability for death or personal injury caused by negligence, fraud, or any other liability that cannot be excluded under UK law.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">7. Termination</h2>
              <p className="text-gray-700">
                We may suspend or terminate your account and remove your content at any time if we believe you have violated these Terms.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">8. Changes to These Terms</h2>
              <p className="text-gray-700">
                We may update these Terms from time to time. The updated version will be posted on this page with a new "Last Updated" date. Continued use of the Site means you accept the changes.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">9. Governing Law</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>These Terms are governed by the laws of England and Wales.</li>
                <li>Any disputes will be subject to the exclusive jurisdiction of the courts of England and Wales.</li>
              </ul>

              <h2 className="text-2xl font-bold mt-8 mb-4">Contact Us</h2>
              <p className="text-gray-700">
                If you have any questions about these Terms, please contact us:
              </p>
              <p className="text-gray-700">
                Email: <a href="mailto:info@rentreview.io" className="text-blue-600 hover:text-blue-800">info@rentreview.io</a>
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}